import React from "react";
import whoImg from "../../assets/images/about/whoImg.png";

export const WhoWe = () => {
  return (
    <div className="whoContainer">
      <div className="container">
        <div className="whoGrid">
          <div className="whoLeft">
            <div className="whoTitle">Who We Are?</div>
            <div className="whoDesc">
              <div>
                SnapBid is an innovative real estate platform that bridges the
                gap between online property discovery and offline bidding. We
                believe that buying property shouldn’t feel rushed or
                manipulated — it should be informed, fair, and user-first.
              </div>
              <div>
                Founded with the vision to make bidding more accessible and
                trust-driven, SnapBid allows you to scroll, spot, express
                interest, and visit before bidding — all without unsolicited
                calls or pressure tactics.
              </div>
            </div>
          </div>
          <div className="whoRight">
            <img src={whoImg} />
          </div>
        </div>
      </div>
    </div>
  );
};
